import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import "./ProtectedRoute.css";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireSuperAdmin?: boolean;
}

const ProtectedRoute = ({
  children,
  requireSuperAdmin = false,
}: ProtectedRouteProps) => {
  const { isAuthenticated, isLoading, admin } = useAuth();

  if (isLoading) {
    return (
      <div className="protected-route-loading">
        <div className="loader-container">
          {/* Animated rings */}
          <div className="ring-wrapper">
            <div className="ring ring-1"></div>
            <div className="ring ring-2"></div>
            <div className="ring ring-3"></div>
          </div>

          {/* Central orb */}
          <div className="central-orb">
            <div className="orb-core"></div>
            <div className="orb-pulse"></div>
          </div>

          {/* Floating particles */}
          <div className="particles">
            {[...Array(12)].map((_, i) => (
              <div key={i} className={`particle particle-${i + 1}`}></div>
            ))}
          </div>
        </div>

        {/* Loading text with typing animation */}
        <div className="loading-text-container">
          <p className="loading-text">
            <span className="text-gradient">LICO</span>
            <span className="dots">
              <span>.</span>
              <span>.</span>
              <span>.</span>
            </span>
          </p>
          <div className="progress-bar">
            <div className="progress-fill"></div>
          </div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  if (requireSuperAdmin && admin?.role !== "super_admin") {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
